import 'css-chunksrc/client/pages/personalSpacePage/synthesis/tasks/sort/styles.scss';export default {
  "sort": "_sort_14j9o_1",
  "row": "_row_14j9o_7",
  "text": "_text_14j9o_24",
  "icon": "_icon_14j9o_32"
};